var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 7C6.25 4.92893 7.92893 3.25 10 3.25C12.0711 3.25 13.75 4.92893 13.75 7C13.75 9.07107 12.0711 10.75 10 10.75C7.92893 10.75 6.25 9.07107 6.25 7ZM10 4.75C8.75736 4.75 7.75 5.75736 7.75 7C7.75 8.24264 8.75736 9.25 10 9.25C11.2426 9.25 12.25 8.24264 12.25 7C12.25 5.75736 11.2426 4.75 10 4.75Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32343 5.64635C1.90431 6.25029 1.75 6.7227 1.75 7C1.75 7.2773 1.90431 7.74971 2.32343 8.35365C2.72857 8.93744 3.33078 9.57028 4.09267 10.155C5.61978 11.3271 7.71345 12.25 10 12.25C12.2865 12.25 14.3802 11.3271 15.9073 10.155C16.6692 9.57028 17.2714 8.93744 17.6766 8.35365C18.0957 7.74971 18.25 7.2773 18.25 7C18.25 6.7227 18.0957 6.25029 17.6766 5.64635C17.2714 5.06256 16.6692 4.42972 15.9073 3.84497C14.3802 2.67292 12.2865 1.75 10 1.75C7.71345 1.75 5.61978 2.67292 4.09267 3.84497C3.33078 4.42972 2.72857 5.06256 2.32343 5.64635ZM3.17941 2.65503C4.90965 1.32708 7.31598 0.25 10 0.25C12.684 0.25 15.0903 1.32708 16.8206 2.65503C17.6874 3.32028 18.4032 4.06244 18.9089 4.79115C19.4006 5.49971 19.75 6.2773 19.75 7C19.75 7.7227 19.4006 8.50029 18.9089 9.20885C18.4032 9.93756 17.6874 10.6797 16.8206 11.345C15.0903 12.6729 12.684 13.75 10 13.75C7.31598 13.75 4.90965 12.6729 3.17941 11.345C2.31262 10.6797 1.59681 9.93756 1.0911 9.20885C0.599371 8.50029 0.25 7.7227 0.25 7C0.25 6.2773 0.599371 5.49971 1.0911 4.79115C1.59681 4.06244 2.31262 3.32028 3.17941 2.65503Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeicon);
export default __webpack_public_path__ + "static/media/eyeicon.da1a0e8c758a196fb6da8402c3a637e0.svg";
export { ForwardRef as ReactComponent };